var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 19.294A2.658 2.658 0 0 0 9 21.508a2.658 2.658 0 0 0 2.626-2.214l.014-.078H6.362l.013.078ZM17.98 15.626c-.215-.215-.434-.398-.646-.574-.893-.741-1.664-1.381-1.664-4.04V8.904c0-3.1-2.179-5.821-5.193-6.503.12-.237.182-.486.182-.742C10.66.744 9.915 0 9 0a1.66 1.66 0 0 0-1.658 1.659c0 .256.061.505.182.742-3.014.682-5.193 3.402-5.193 6.503v2.108c0 2.659-.77 3.299-1.663 4.04-.213.176-.432.359-.647.574l-.02.02v2.091h18v-2.091l-.02-.02Z",
    fill: "#333"
  })));
};
export default SvgNotification;